<template>
    <section class="remains">
        <div class="remains__heading">
            <SubHeader
                :title="$t('pages.remains.remains')"
                :crumbs="textContent['crumbs']"
            />

            <v-btn
                class="remains__download"
                color="#967adc"
                dark
                @click="download"
            >
                {{ $t('pages.remains.download') }}
            </v-btn>
        </div>

        <div v-if="!loading && headers.length && processedTable.length">
            <div class="remains__table-scroll">
                <table class="remains__table">
                    <thead class="remains__table-head">
                        <tr class="remains__table-row">
                            <th class="sticky-col remains__table-column">
                                {{ $t('pages.remains.length') }}
                            </th>
                            <th
                                v-for="group in processedTable"
                                :key="group.color"
                                :colspan="group.items.length"
                                class="remains__table-column"
                            >
                                {{ group.color }}
                            </th>
                        </tr>
                        <tr class="remains__table-row">
                            <th class="sticky-col remains__table-column"></th>
                            <template v-for="group in processedTable">
                                <th
                                    v-for="item in group.items"
                                    :key="group.color + '-' + item.type"
                                    class="remains__table-column"
                                >
                                    {{ item.type }}
                                </th>
                            </template>
                        </tr>
                    </thead>

                    <tbody>
                        <tr
                            v-for="header in headers"
                            :key="header"
                            class="remains__table-row"
                        >
                            <td class="sticky-col remains__table-item">
                                {{ header }}
                            </td>
                            <template v-for="group in processedTable">
                                <td
                                    v-for="item in group.items"
                                    :key="
                                        group.color +
                                        '-' +
                                        item.type +
                                        '-' +
                                        header
                                    "
                                    class="remains__table-item"
                                >
                                    {{ item[header] }}
                                </td>
                            </template>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div v-else-if="loading">Loading...</div>
    </section>
</template>

<script>
import axios from '@/api/axios'
import SubHeader from '@/components/common/sub-header'
import languageMixin from '@/mixins/language.mixin'

export default {
    name: 'WarehouseStock',
    components: { SubHeader },
    mixins: [languageMixin],
    data() {
        return {
            headers: [],
            calculations: [],
            loading: true,
        }
    },
    computed: {
        processedTable() {
            return this.calculations
                ? this.processTableData(this.calculations)
                : []
        },
    },
    mounted() {
        this.fetchTableData()
    },
    methods: {
        async fetchTableData() {
            this.loading = true
            try {
                const response = await axios.get('/base/api/wig-groups')
                this.headers = response.data.headers
                this.calculations = response.data.calculations
            } catch (error) {
                console.error(error)
            } finally {
                this.loading = false
            }
        },
        async download() {
            try {
                const { data } = await axios.get(
                    '/base/api/wig-groups/download',
                    {
                        responseType: 'blob',
                    }
                )

                const fileBlob = new Blob([data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                })

                const fileUrl = URL.createObjectURL(fileBlob)

                const downloadLink = document.createElement('a')
                downloadLink.href = fileUrl
                downloadLink.download = 'wig-groups.xlsx'
                document.body.appendChild(downloadLink)
                downloadLink.click()

                document.body.removeChild(downloadLink)
                URL.revokeObjectURL(fileUrl)
            } catch (error) {
                console.error('Failed to download file:', error)
            }
        },
        processTableData(rawCalcs) {
            return Object.entries(rawCalcs).map(([color, items]) => ({
                color,
                items,
            }))
        },
    },
}
</script>

<style scoped lang="scss">
.sticky-col {
    position: sticky;
    left: 0;
    background: #fff;
    z-index: 2;

    @include for-hebrew {
        left: auto;
        right: 0;
    }
}

.remains {
    min-height: 100%;
    display: flex;
    flex-direction: column;

    &__heading {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    &__download {
        margin-bottom: 25px;
    }

    &__table-scroll {
        overflow-x: auto;
        width: 100%;
        padding-bottom: 8px;
    }

    &__table {
        border-collapse: collapse;
        min-width: max-content;
    }

    &__table-column,
    &__table-item {
        padding: 8px;
        border: 1px solid #ccc;
        text-align: center;
        min-width: 160px;
        white-space: nowrap;
    }

    &__table-head .sticky-col {
        z-index: 3;
    }
}
</style>
